import { useEffect, useRef, useState } from 'react';
import { io } from 'socket.io-client';
import { useAuth } from '../context/AuthContext';

export function useSocket(namespace = '/') {
  const { accessToken } = useAuth();
  const socketRef = useRef(null);
  const [connected, setConnected] = useState(false);

  useEffect(() => {
    if (!accessToken) return;
    const SERVER_URL = process.env.REACT_APP_SERVER_URL || window.location.origin;

    const socket = io(SERVER_URL + namespace, {
      auth:                 { token: accessToken },
      transports:           ['websocket'],
      withCredentials:      true,
      reconnection:         true,
      reconnectionAttempts: 10,
      reconnectionDelay:    2000,
      reconnectionDelayMax: 30_000,
      randomizationFactor:  0.3,
      timeout:              20_000,
    });

    socketRef.current = socket;

    const onConnect    = () => setConnected(true);
    const onDisconnect = () => setConnected(false);

    socket.on('connect',    onConnect);
    socket.on('disconnect', onDisconnect);

    if (process.env.NODE_ENV === 'development') {
      socket.on('connect',       ()  => console.log('[socket] connected', socket.id));
      socket.on('disconnect',    (r) => console.warn('[socket] disconnected', r));
      socket.on('connect_error', (e) => console.error('[socket] error', e.message));
    }

    return () => {
      socket.removeAllListeners();
      socket.disconnect();
      socketRef.current = null;
      setConnected(false);
    };
  }, [accessToken, namespace]);

  return { socketRef, connected };
}

export default useSocket;